import React, { useEffect, useState, useCallback, useRef } from 'react';
import {
    Container,
    Blade,
    DataGridTable,
    Toast as toast
} from 'components';
import { carrierListTableColumns } from '../agentsListTableData';
import { GridRowSelectionModel } from '@mui/x-data-grid';
import {
    massiveCarrierAssign,
    massiveCarrierUnassign,
    carrierAssign,
    carrierUnassign
} from 'api';
import styles from '../agentsList.module.scss';
import strings from 'strings';
import { reportException } from 'tools/logs';

const t = strings.AGENT_MANAGEMENT;

interface ICarriersForAgentsProps {
    open: boolean;
    currentAgent: any;
    motorCarriersForAgents: any;
    isAssignedCarriers: boolean;
    loading: boolean;
    onClose: () => void;
}

const CarriersForAgents: React.FC<ICarriersForAgentsProps> = (props: ICarriersForAgentsProps) => {
    const { open, currentAgent, motorCarriersForAgents, isAssignedCarriers, loading, onClose } = props;
    const [btnLoader, setBtnLoader] = useState(false);
    const [disableBtn, setDisableBtn] = useState(true);
    const selectedRowsRef = useRef<GridRowSelectionModel>([])

    useEffect(() => {
        setDisableBtn(selectedRowsRef.current.length === 0);
    }, []);

    const handleClose = () => {
        selectedRowsRef.current = [];
        onClose();
    };

    const handleCheckboxSelection = useCallback((selections: GridRowSelectionModel) => {
        selectedRowsRef.current = selections;
        setDisableBtn(selections.length === 0)
    }, []);

    const handleAssignUnassign = useCallback((action: any, domain: string, agentId: any, payload: any) => {
        setBtnLoader(true);
        action(domain, agentId, payload)
            .then((response: any) => toast({ id: `handleCarrierAgentToast`, title: response?.message }))
            .catch((error: any) => {
                reportException(error)
            })
            .finally(() => {
                setBtnLoader(false);
                handleClose();
            });
    }, []);

    const onSubmit = () => {
        const { domain, agentId } = currentAgent;
        if (selectedRowsRef.current.length === 0) {
            console.error('No rows selected');
            return;
        }

        if (isAssignedCarriers) {
            selectedRowsRef.current.length === 1
                ? handleAssignUnassign(carrierUnassign, domain, agentId, selectedRowsRef.current[0])
                : handleAssignUnassign(massiveCarrierUnassign, domain, agentId, selectedRowsRef.current);
        } else {
            selectedRowsRef.current.length === 1
                ? handleAssignUnassign(carrierAssign, domain, agentId, selectedRowsRef.current[0])
                : handleAssignUnassign(massiveCarrierAssign, domain, agentId, selectedRowsRef.current);
        }
    };

    const MotorCarriersBlade = () => (
        <Container className={styles.bladeBodyContainer}>
            <Container className={styles.resultsContainer} sx={{ mt: 1 }}>
                <DataGridTable
                    loading={loading}
                    data={motorCarriersForAgents || []}
                    columns={carrierListTableColumns.columns}
                    getRowId={(row: any) => row?.carrierId}
                    showFilter={true}
                    multiSearchFilter={false}
                    showTitle={false}
                    checkboxSelection={true}
                    reduceHeight={210}
                    handleCheckboxSelection={handleCheckboxSelection}
                    customSelectionModel={selectedRowsRef.current}
                />
            </Container>
        </Container>
    );

    return (
        <Blade
            open={open}
            title={isAssignedCarriers ? t.ASSIGNED_CARRIERS : t.AVAILABLE_CARRIERS}
            onClose={handleClose}
            bodyNode={<MotorCarriersBlade />}
            size={'lg'}
            footerBtns={{
                primary: {
                    id: "carriersForAgentsBlade",
                    label: isAssignedCarriers ? t.UNASSIGN : t.ASSIGN,
                    onClick: onSubmit,
                    loading: btnLoader,
                    disabled: btnLoader || disableBtn,
                },
                secondary: {
                    id: "closeCarriersForAgentsBlade",
                    label: 'Cancel',
                    variant: 'outlined',
                    onClick: handleClose
                },
            }}
        />
    );
};

export default CarriersForAgents;
